export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_service-match-197/artifacts/2f6maih5_Care-4u%20logo.png";

export const MUSIC_URL =
  "https://www.mfiles.co.uk/mp3-downloads/mozart-eine-kleine-nachtmusik-1-allegro.mp3";

export const BRANCH_EMBLEMS = [
  { name: "Army", url: "/emblems/army.png" },
  { name: "Navy", url: "/emblems/navy.png" },
  { name: "Air Force", url: "/emblems/airforce.png" },
  { name: "Marine Corps", url: "/emblems/marines.png" },
  { name: "Coast Guard", url: "/emblems/coastguard.png" },
];

export const BADGE_STYLE = {
  Bronze: { bg: "linear-gradient(135deg,#d8a373,#a97142)", color: "#3d2410" },
  Silver: { bg: "linear-gradient(135deg,#f1f5f9,#94a3b8)", color: "#1e293b" },
  Gold: { bg: "linear-gradient(135deg,#fde68a,#d4a017)", color: "#5c4300" },
  Platinum: { bg: "linear-gradient(135deg,#e5e7eb,#9ca3af)", color: "#111827" },
  Diamond: { bg: "linear-gradient(135deg,#a5f3fc,#38bdf8)", color: "#083344" },
  "Double Diamond": { bg: "linear-gradient(135deg,#c4b5fd,#7c3aed)", color: "#fff" },
  "God-Level": { bg: "linear-gradient(135deg,#fca5a5,#9b111e,#fbbf24)", color: "#fff" },
};

export const BRANCHES = ["Army", "Navy", "Air Force", "Marine Corps", "Coast Guard"];

export const CASHAPP_TAG = "$care4unet";

export const NO_BAD_APPLES_BADGE =
  "https://static.prod-images.emergentagent.com/jobs/4cc4b9ea-4cfb-49a2-a478-96128e1259a4/images/1d399a6e4ed7dc2638663e8e0aa9d7d4ef86d0bad06186bd7df12615ff924ec2.jpeg";

export const WEEKDAYS = [
  { key: "monday", label: "Monday" },
  { key: "tuesday", label: "Tuesday" },
  { key: "wednesday", label: "Wednesday" },
  { key: "thursday", label: "Thursday" },
  { key: "friday", label: "Friday" },
  { key: "saturday", label: "Saturday" },
  { key: "sunday", label: "Sunday" },
];
